import { render, staticRenderFns } from "./ProfiteerSection.vue?vue&type=template&id=346d0084"
import script from "./ProfiteerSection.vue?vue&type=script&lang=js"
export * from "./ProfiteerSection.vue?vue&type=script&lang=js"
import style0 from "./ProfiteerSection.vue?vue&type=style&index=0&id=346d0084&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports